if (!window.retailer) {
  window.retailer = {};
}

!(function (retailer, debug) {
  if (debug) {
    console.log("In api.js");
  }
  // api calls
  retailer.apiPostFreeplayRoundPriceAction = function (requestJson, cb) {
    $.ajax({
      url: "/api/freeplayRoundPriceAction/",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: cb,
      error: (err) => console.log("WARNING: api error", err),
    });
  };

  retailer.apiSendStudentKey = function (requestJson) {
    $.ajax({
      url: "/api/sendStudentKey/",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: function (data) {
        alert(data.message);
      },
      error: (err) => console.log("WARNING: api error", err),
    });
  };

  retailer.apiGetCompetitionRoundData = function (requestJson, cb) {
    $.ajax({
      url: "/api/clientRoundData",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiGetCompetitionData = function (requestJson, cb) {
    $.ajax({
      url: "/api/clientCompetitionData",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiCompetitionRoundPriceAction = function (requestJson, cb) {
    $.ajax({
      url: "/api/competitionRoundPriceAction",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiCompetitionListForStudent = function (cb) {
    $.ajax({
      url: "/api/competition/studentlist",
      contentType: "application/json",
      method: "POST",
      data: {},
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiCompetitionListForTeacher = function (cb) {
    $.ajax({
      url: "/api/competition/teacherlist",
      contentType: "application/json",
      method: "POST",
      data: {},
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiDeleteCompetition = function (competition_id, cb) {
    $.ajax({
      url: "/api/competition/delete",
      contentType: "application/json",
      method: "POST",
      data: JSON.stringify({ competition_id: competition_id }),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiEraseCompetition = function (competition_id, cb) {
    $.ajax({
      url: "/api/competition/result/erase",
      contentType: "application/json",
      method: "POST",
      data: JSON.stringify({ competition_id: competition_id }),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiEraseResultById = function (competition_id, result_id, cb) {
    $.ajax({
      url: "/api/competition/result/eraseById",
      contentType: "application/json",
      method: "POST",
      data: JSON.stringify({
        competition_id: competition_id,
        result_id: result_id,
      }),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiCreateCompetition = function (requestJson, cb) {
    $.ajax({
      url: "/api/competition/create",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiEditCompetition = function (requestJson, cb) {
    $.ajax({
      url: "/api/competition/update",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiCompetitionSummary = function (competition_id, cb) {
    $.ajax({
      url: "/api/competition/result/summary",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({ competition_id: competition_id }),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiViewSteps = function (requestJson, cb) {
    $.ajax({
      url: "/api/competition/result/view",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(requestJson),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiPasswd = function (formData, cb, error) {
    $.ajax({
      type: "POST",
      url: "/passwd",
      data: formData,
      success: cb,
      error: error,
    });
  };

  retailer.apiReset = function (username, cb, error) {
    $.ajax({
      type: "POST",
      url: "/reset",
      contentType: "application/json",
      data: JSON.stringify({ username: username }),
      success: cb,
      error: error,
    });
  };

  retailer.apiRobotList = function (cb) {
    $.ajax({
      url: "/api/competition/robotlist",
      type: "POST",
      contentType: "application/json",
      data: {},
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  retailer.apiRobotRankList = function (competition_id, cb) {
    $.ajax({
      url: "/api/competition/robotranklist",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({ competition_id: competition_id }),
      success: cb,
      error: function (jqXHR, status, error) {
        alert(jqXHR.responseJSON.error);
      },
    });
  };

  function main() {}
  main();
})(window.retailer, window.retailer.debug);



// WEBPACK FOOTER //
// ../public/js/retailer.api.js